import { Form, FormInstance, Input, Typography } from "antd";

const SinglePackagePrice = ({
  form,
  priceType,
  packageType,
  formItemNameKm,
  formItemNameEur,
}: {
  form: FormInstance<any>;
  priceType: string;
  packageType: string;
  formItemNameKm: string;
  formItemNameEur: string;
}) => {
  return (
    <div className="bg-slate-20 xl:w-1/2">
      <Typography className="text-xs xl:text-sm">
        {priceType === "regular" ? (
          `Cijena Paketa ${packageType} [KM / EUR]`
        ) : (
          <>
            <span className="text-custom-pink-900 font-bold">EARLY </span>
            Paket {packageType} [KM / EUR]
          </>
        )}
      </Typography>

      <div className="flex gap-3 mt-1 h-[50px]">
        <Form.Item
          name={formItemNameKm}
          rules={[
            {
              required: true,
              message: "Unesi!",
            },
          ]}
        >
          <Input
            placeholder="320"
            min={0}
            type="number"
            className="text-xs"
            suffix={
              <>
                <span className="text-xs text-custom-pink-900">KM</span>
              </>
            }
            onChange={(e) => {
              const kmValue = parseFloat(e.target.value);
              const eurValue = (kmValue / 1.96).toFixed(2);
              form.setFieldsValue({
                [formItemNameEur]: eurValue,
              });
            }}
          />
        </Form.Item>

        <Form.Item name={formItemNameEur}>
          <Input
            placeholder="320"
            type="number"
            className="bg-white cursor-default text-xs"
            disabled
            suffix={
              <>
                <span className="text-xs text-custom-pink-900">€</span>
              </>
            }
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default SinglePackagePrice;
